<template>
  <div>
    <BaseFrame
      :showCtrls="false"
    >
    <div slot="content">
      <loadingSpan v-if='loading' fix>加载中...</loadingSpan>
    <div class="content">
      <lk-card title="报表查询限制" class="mb16">
        <div class="tableArea">
          <lk-table :columns='tableSearchColumns' :data='tableSearchData ' border ></lk-table>
        </div>
      </lk-card>
      <lk-card title="抽盘规则配置" class="mb16">
        <div class="tableArea">
          <lk-table :columns='tableConfigColumns' :data='tableConfigData ' border ></lk-table>
        </div>
      </lk-card>
      <lk-card title="批量创建盘点计划" class="mb16">
        <div class="btnArea" v-if="handlePermission('batchCreateCheckPlan')">
        <lk-button type="primary" @click="toCreatePlan">批量创建盘点计划</lk-button>
        </div>
        <div class="tableArea">
          <lk-table :columns='checkPlanColumns' :data='checkPlanData' border ></lk-table>
        </div>
        <lk-Page
          class="pages"
          show-sizer
          show-elevator
          show-total
          :page-size="size"
          v-if="!disablePage"
          @on-page-size-change='handlePageSize'
          @on-change='handlePage'
          :total = 'count'
          :page-size-opts='[20,30,50,100]'
          :current="page"
        ></lk-Page>
      </lk-card>
      <lk-card title="盘点规划配置" class="mb16">
        <div class="tableArea">
          <lk-table :columns='columns' :data='tableData' border ></lk-table>
        </div>
      </lk-card>
    </div>
    </div>
    </BaseFrame>
  </div>
</template>
<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import utils from '@/libs/utils';
import tools from '@/services/tools';
import loadingSpan from '@/components/LoadingSpan.vue';
import queryMixins from '../../../mixins/queryMixins';
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import { t } from 'iview/src/locale';


export default {
  name: 'stocktakingRuleList',
  components: {
    loadingSpan,
    QueryFrame,
    BaseFrame,
  },
  mixins: [queryMixins],
  computed: {},
  data() {
    return {
      size: 20,
      page: 1,
      count: 0,
      loading: false,
      tableSearchData: [{
        ruleName: '规则名称',
        startTime: 1648582200000,
        modifiedTime: 1648582200000,
        modifiedUserName: '',
        ruleStatus: 1,
      }],
      tableSearchColumns: [
        {
          title: '规则名称',
          key: 'ruleName',
          minWidth: 116,
        },
        {
          title: '当前限制时间段',
          key: 'startTime',
          minWidth: 116,
          render: (h, { row, index }) => h('span', `${utils.formatTime(row.startTime)} ~ ${utils.formatTime(this.tableSearchData[index].endTime)}`),
        },
        {
          title: '修改时间',
          key: 'modifiedTime',
          minWidth: 116,
          render: (h, { row }) => h('span', utils.formatTime(row.modifiedTime)),
        },
        {
          title: '修改人',
          key: 'modifiedUserName',
          minWidth: 100,
        },
        {
          title: '状态',
          key: 'ruleStatus',
          minWidth: 80,
          render: (h, { row }) => h('lk-switch', {
            props: {
              value: row.ruleStatus === 1 ? true : false,
              size: 'large',
            },
            on: {
              'on-change': (value) => {
                row.ruleStatus = value;
                const params = {
                  ruleStatus: value ? 1 : 2,
                  id: row.id,
                };
                tools.updateRuleStatus(params).then((res) => {
                  if (res.data.status === 200) {
                    this.$Message.success('更新成功');
                  } else {
                    this.$Message.error(res.data.error);
                  }
                }).catch((err) => {
                  utils.handleError(err);
                });
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, '启用'),
            h('span', {
              slot: 'close'
            }, '禁用'),
          ]),
        },
        {
          title: '操作',
          minWidth: 26,
          render: (h, { row }) => h('div', [
            h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'stocktakingRuleCheck',
                    params: {
                      id: row.id,
                    },
                  });
                },
              },
            }, '查看'),
            h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'stocktakingRuleEdit',
                    params: {
                      id: row.id,
                    },
                  });
                },
              },
            }, '编辑'),
          ]),
        },
      ],
      tableConfigData: [{
        ruleName: '规则名称',
        startTime: 1648582200000,
        modifiedTime: 1648582200000,
        modifiedUserName: '',
        ruleStatus: 1,
      }],
      tableConfigColumns: [
        {
          title: '规则名称',
          key: 'ruleName',
          minWidth: 116,
        },
        {
          title: '当前抽盘规则',
          key: 'goodsConditionDesc',
          minWidth: 116,
        },
        {
          title: '修改时间',
          key: 'modifiedTime',
          minWidth: 116,
          render: (h, { row }) => h('span', utils.formatTime(row.modifiedTime)),
        },
        {
          title: '修改人',
          key: 'modifiedUserName',
          minWidth: 100,
        },
        {
          title: '操作',
          minWidth: 26,
          render: (h, { row }) => h('div', [
            h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
              },
              on: {
                click: () => {
                  console.log('lvlvlvlvlv');
                  this.$router.push({
                    name: 'stocktakingRuleCheck',
                    params: {
                      id: 4,
                    },
                  });
                },
              },
            }, '查看'),
            h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'stocktakingRuleEdit',
                    params: {
                      id: 4,
                    },
                  });
                },
              },
            }, '编辑'),
          ]),
        },
      ],
      checkPlanData: [{
        name: '盘点计划名称',
        operatorTime: 1648582200000,
        ruleStatus: 1,
      }],
      checkPlanColumns: [
        {
          title: '盘点计划名称',
          key: 'name',
          minWidth: 116,
        },
        {
          title: '盘点类型',
          key: 'operatorTypeName',
          minWidth: 116,
        },
        {
          title: '盘点方式',
          key: 'operatorPatternName',
          minWidth: 116,
        },
        {
          title: '门店范围',
          key: 'authStoreNames',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '盘点时间',
          key: 'operatorTime',
          minWidth: 116,
          render: (h, { row }) => h('span', utils.formatTime(row.operatorTime)),
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 116,
          render: (h, { row }) => h('span', utils.formatTime(row.createTime)),
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 116,
        },
      ],
      tableData: [{
        ruleName: '规则名称',
        modifiedTime: 1648582200000,
        ruleStatus: 1,
      }],
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
        },
        {
          title: '规则名称',
          key: 'ruleName',
          minWidth: 116,
        },
        {
          title: '修改时间',
          key: 'modifiedTime',
          minWidth: 116,
          render: (h, { row }) => h('span', utils.formatTime(row.modifiedTime)),
        },
        {
          title: '状态',
          key: 'ruleStatus',
          minWidth: 80,
          render: (h, { row }) => h('lk-switch', {
            props: {
              value: row.ruleStatus === 1 ? true : false,
              size: 'large'
            },
            on: {
              'on-change': (value) => {
                row.ruleStatus = value;
                const params = {
                  ruleStatus: value ? 1 : 2,
                  id: row.id
                }
                tools.updateRuleStatus(params).then((res) => {
                  if (res.data.status === 200) {
                    this.$Message.success('更新成功');
                  } else {
                    this.$Message.error(res.data.error);
                  }
                }).catch(err => {
                  utils.handleError(err);
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, '启用'),
            h('span', {
              slot: 'close'
            }, '禁用'),
          ]),
        },
        {
          title: '操作',
          minWidth: 26,
          render: (h, { row }) => h('div', [
            h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'stocktakingRuleCheck',
                    params: {
                      id: row.id,
                    },
                  });
                },
              },
            }, '查看'),
            h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'stocktakingRuleEdit',
                    params: {
                      id: row.id,
                    },
                  });
                },
              },
            }, '编辑'),
          ]),
        },
      ],
    };
  },
  methods: {
    getDate() {
      tools.getRuleList().then((res) => {
        this.loading = true;
        if (res.data.status === 200) {
          this.loading = false;
          if (res.data.data && res.data.data instanceof Array) {
            this.tableData = res.data.data.slice(0, 2);
            this.tableSearchData = res.data.data.slice(2, 3);
            this.tableConfigData = res.data.data.slice(3, 4);
          }
        } else {
          this.loading = false;
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.loading = false;
        utils.handleError(err);
      });
    },
    toCreatePlan() {
      this.$router.push({name: 'batchCreateCheckPlan'})
    },
    handlePageSize(size) {
      this.size = size;
      this.getHistoryData();
    },
    handlePage(page) {
      this.page = page;
      this.getHistoryData();
    },
    getHistoryData() {
      const historyParams = { page: this.page, size: this.size };
      tools.getHistoryList(historyParams).then((res) => {
        this.loading = true;
        if (res.data.status === 200) {
          this.loading = false;
          this.checkPlanData = res.data.data.list;
          this.count = res.data.data.count;
        } else {
          this.loading = false;
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.loading = false;
        utils.handleError(err);
      });
    },
  },
  created() {
  },
  mounted() {
    this.getHistoryData();
    this.getDate();
  },
};
</script>
<style lang="less" scoped>
  .Info {
    background-color: #fff;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 10px 0 5px 15px;
    .title {
      font-family: regular;
      font-weight: bold;
      font-size: 12px;
      color:#515a6e;
    }
  }
  .content {
    margin: 0px !important;
    padding: 0px !important;
  }
  .btnArea {
    margin-bottom: 10px;
  }

  .pages{
  margin-top: 16px;
  text-align: right
}
</style>
